var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"selftips",style:({ borderLeft: `5px solid ${_vm.bordercolor}` })},[_c('span',[_vm._v(_vm._s(_vm.title))])])
}
var staticRenderFns = []

export { render, staticRenderFns }